import './style.styl'
import { sel, selAll, onDomReady, addSplideClasses, connectSplideArrows, connectSplideBullets, vh, notHiddenAB, dev } from './utils'
import { lenis } from './lenis'
import Home from './home'
import Home2 from './home2'
import Event from './event'
import Zora from './zora'
import EventPeter from './event-peter'
import Careers from './careers'
import SignupVideo from './signup-video'
import SignupVideoV2 from './signupVideoV2'
import Epic from './epic'
import EpicTest from './epic-test'
import Epic0814 from './epic-0814'
import Epic0815 from './epic-0815'
import Epic0816 from './epic-0816'
import Epic0822 from './epic-0822'
import Epic0827 from './epic-0827'
import Epic0829 from './epic-0829'
import membershipV2 from './membership-v2'
import Plans from './plans'
import Estate from './estate'
import DownloadPdf from './download-pdf'
import DownloadLogos from './download-logos'
import Exec25 from './exec-25'

import Home0912 from './home-0912'
import Home1105 from './home-1105'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import Location from './location'
import Thank from './thank'
import Lp from './lp'
import Splide from '@splidejs/splide'
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll'
import OldHome from './old-home'
import Exec from './exec'
import Membership from './membership'
import Blog2 from './blog2'
import Schedule from './schedule'
import SplitType from 'split-type'

if (dev) {
  setTimeout(() => {
    console.log('Removing cgptcb-body')
    sel('#cgptcb-body').remove()
  }, 1000)
}

selAll('.js-init').forEach((el) => {
  el.classList.remove('js-init')
})
//
lenis.on('scroll', ScrollTrigger.update)
gsap.ticker.add((time) => {
  lenis.raf(time * 1000)
})
gsap.ticker.lagSmoothing(0)

const _dataPage = sel('.page-wrapper') || sel('body')
const dataPage = _dataPage?.getAttribute('data-page')

const initModules = import.meta.glob('./initComps/*.js', { eager: true })
for (const path in initModules) {
  // initModules[path]().then((mod) => {
  //   mod.default()
  // })

  initModules[path].default?.()
}

const modules = import.meta.glob('./comps/*.js')
for (const path in modules) {
  modules[path]().then((mod) => {
    mod.default()
  })
}

// console.log('tt')

switch (dataPage) {
  case 'home':
    Home()
    break
  case 'home2':
    Home2()
    break
  case 'membership':
    Membership()
    break
  case 'location':
    Location()
    break
  case 'thank':
    Thank()
    break
  case 'lp':
    Lp()
    break
  case 'old-home':
    OldHome()
    break
  case 'exec':
    Exec()
    break
  case 'blog2':
    Blog2()
    break
  case 'schedule':
    Schedule()
    break
  case 'zora':
    Zora()
    break
  case 'event-peter':
    EventPeter()
    break
  case 'event':
    Event()
    break
  case 'careers':
    Careers()
    break
  case 'signup-video':
    SignupVideo()
    break
  case 'signup-video-v2':
    SignupVideoV2()
    break
  case 'epic':
    Epic()
    break
  case 'epic-test':
    EpicTest()
    break
  case 'epic-0814':
    Epic0814()
    break
  case 'epic-0815':
    Epic0815()
    break
  case 'epic-0816':
    Epic0816()
    break
  case 'epic-0822':
    Epic0822()
    break
  case 'epic-0827':
    Epic0827()
    break
  case 'epic-0829':
    Epic0829()
    break
  case 'membership-v2':
    membershipV2()
    break
  case 'home-0912':
    Home0912()
    break
  case 'home-1105':
    Home1105()
    break
  case 'estate':
    Estate()
    break
  case 'plans':
    Plans()
    break
  case 'download-pdf':
    DownloadPdf()
    break
  case 'download-logos':
    DownloadLogos()
    break
  case 'exec-25':
    Exec25()
    break
  case 'error':
    Error()
    break
  default:
    console.log('unknown data-page:', dataPage)
}

// Service cards
const overviewList$ = sel('.lp-overview__list')
if (overviewList$) {
  overviewList$.classList.add('is--closed')
  const overviewBtn$ = sel('#overview-btn')
  // if (!overviewBtn$) return console.error('overviewBtn$ not found')

  const overviewBtnText$ = overviewBtn$.querySelector('.accordion__a__p')
  overviewBtn$.onclick = () => {
    if (overviewList$.classList.contains('is--closed')) {
      overviewBtnText$.textContent = '+ View Less Diagnostics'
    } else {
      overviewBtnText$.textContent = '+ View More Diagnostics'
    }
    overviewList$.classList.toggle('is--closed')
  }
}

// Faq chat link
const chatLink$ = document.querySelector('#faq-chat')

if (chatLink$) {
  chatLink$.onclick = () => {
    LO.messenger.open()
    console.log('chat clicked')
  }
}

// FAQ Accordion
onDomReady(() => {
  const faqDd = selAll('.faq__accordion')
  const shiftX = -1000

  faqDd.forEach((faq, i) => {
    const faqTitle$ = faq.querySelector('.faq__question-w')
    const faqDdIco$ = faq.querySelector('.faq__question__ico-w')
    const faqP$ = faq.querySelector('.faq__answer__p')
    const faqNav$a = faq.querySelectorAll('.faq__answer__li')
    const faqBg$ = faq.querySelector('.faq__bg-w')

    // console.log(faq)
    const faqLi$a = faq.querySelectorAll('.faq__answer__li-w')
    faqLi$a.forEach((faqLi, i) => {
      const nav = faqLi.querySelector('.faq__answer__li')
      const modalW$ = faqLi.querySelector('.faq__item__mod-w')
      const modalClose$ = faqLi.querySelector('.faq__item__x-w')
      const modalCloseBg$ = faqLi.querySelector('.faq__item__mod-bg')
      const faqTl = gsap.timeline({
        defaults: {
          duration: 1.2,
          ease: 'none',
        },
        paused: true,
      })

      faqTl
        .to(faqDdIco$, { opacity: 0, duration: 0.3 }, 0)
        .to([faqTitle$, faqP$, faqNav$a], { x: shiftX, opacity: 0 }, 0)
        .to(faqBg$, { x: shiftX / 2 }, 0)
        .set(modalW$, { display: 'block' }, 0)
        .fromTo(modalW$, { autoAlpha: 0 }, { autoAlpha: 1 }, 0)
        .from(modalW$, { x: 200 }, 0)

      nav.onclick = () => {
        //   faqTl.play()
        gsap.to(faqTl, { time: faqTl.duration(), duration: faqTl.duration(), ease: 'power4.out' })
      }
      ;[modalClose$, modalCloseBg$].forEach((el) => {
        el.onclick = () => {
          // faqTl.reverse()
          gsap.to(faqTl, { time: 0, duration: faqTl.duration(), ease: 'power4.out', overwrite: true })
          // gsap.set(modalW$, { display: 'none' }, 0)
        }
      })
    })
  })
})

// remove play buttons in the power saving mode
const vids$a = selAll('video')

vids$a.forEach((video) => {
  const promise = video.play()
  promise
    ?.catch(() => {
      const img$ = video.style.backgroundImage
      const parent$ = video.parentElement
      video.style.display = 'none'
      parent$.style.backgroundImage = img$
      parent$.style.backgroundPosition = 'center'
      parent$.style.backgroundSize = 'cover'
    })
    .then(() => {
      video.play()
    })
})

function storyMainSplide() {
  const prefix = 'stories'
  const el = '.' + prefix + '__slider'
  if (!sel(el)) return
  addSplideClasses(el)

  const slider = new Splide(el, {
    arrows: false,
    pagination: false,
    type: 'fade',
    gap: '0px',
    perPage: 1,
    // loop: true,
    rewind: true,
    speed: 1500,
    autoplay: 'true',
    // easing: 'cubic-bezier(0.16, 1, 0.3, 1)',
  }).mount()
  connectSplideArrows(slider, prefix + '__arrows', '.round-arrow')
  connectSplideBullets(slider, prefix + '__bullets')
}
storyMainSplide()

function storyMoreSplide() {
  const prefix = 'stories-more'
  const el = sel('.' + prefix + '__slider')
  if (!el) return
  const list$ = el.querySelector('.w-dyn-items')
  const item$a = list$.querySelectorAll('.w-dyn-item')
  let div = document.createElement('div')
  div.classList.add('stories__mod-w')
  item$a.forEach((item, i) => {
    const modal$ = item.querySelector('.mod-w')
    if (!modal$) return
    // modal.querySelector('.mod__info').setAttribute('data-modal', '')
    const modalX$ = modal$.querySelector('.mod__x-w')
    const modalBg$ = modal$.querySelector('.mod-bg')
    // console.log(modalX$, modalBg$)

    div.appendChild(modal$)
    const modalTl = gsap.timeline({
      defaults: {
        duration: 1.2,
        ease: 'none',
      },
      paused: true,
    })
    modalTl.set(modal$, { display: 'block' }, 0).fromTo(modal$, { autoAlpha: 0, x: '5rem' }, { autoAlpha: 1, x: '0' }, 0)

    item.onclick = () => {
      console.log('clicked', i)
      gsap.to(modalTl, { time: modalTl.duration(), duration: modalTl.duration(), ease: 'power4.out' })
    }
    ;[modalX$, modalBg$].forEach((el) => {
      el.onclick = () => {
        gsap.to(modalTl, { time: 0, duration: modalTl.duration(), ease: 'power4.out', overwrite: true })
      }
    })
  })

  const storiesSec = sel('.stories-sec') || sel('.old-stories-sec')
  storiesSec.appendChild(div)

  addSplideClasses(el)

  const slider = new Splide(el, {
    arrows: false,
    pagination: false,
    gap: '1.25rem',
    perPage: 2,
    type: 'loop',
    autoplay: 'pause',
    /* intersection: {
        inView: {
          autoplay: true,
        },
        outView: {
          autoplay: false,
        },
      },*/
    speed: 1500,
    easing: 'cubic-bezier(0.16, 1, 0.3, 1)',
    autoScroll: { speed: 1, autoStart: true },
    breakpoints: {
      768: {
        perPage: 1,
      },
    },
  }).mount({ AutoScroll })
}
storyMoreSplide()

// Plans services
const plan$ = sel('#plan-mob')
if (plan$) {
  const serviceA$ = selAll('.membership__service-w')
  serviceA$.forEach((service) => {
    const toggle$ = service.querySelector('.imaging-dropdown-toggle')
    const plusIco$ = service.querySelector('.dropdown-plus-icon')
    const minusIco$ = service.querySelector('.dropdown-minus-icon')
    const list$ = service.querySelector('.membership__service__list')
    list$.classList.add('toggle--closed')
    toggle$.onclick = () => {
      list$.classList.toggle('toggle--closed')
      const closed = list$.classList.contains('toggle--closed')

      plusIco$.style.display = closed ? 'block' : 'none'
      minusIco$.style.display = closed ? 'none' : 'block'
    }
  })
}

// Append ga userid to /signup links
// console.log('signup links')
const signup$a = Array.from(document.querySelectorAll('a[href], button[href]')).filter((el) => {
  try {
    // Resolve the href relative to the current document
    const url = new URL(el.getAttribute('href'), window.location.href)
    // Check that the URL is from the current domain and its pathname ends with "/signup"
    // console.log('signup link', url.origin)
    const path = url.pathname
    const rightPath = path.endsWith('/signup') || path.endsWith('/signup/executive') || path.endsWith('/contact-us')
    return url.origin === window.location.origin && rightPath
  } catch (e) {
    // In case of an invalid URL
    return false
  }
})

// Persist gclid from URL to localStorage (if present), then read it back
let _gclid = ''
try {
  const gclidFromUrl = new URL(window.location.href).searchParams.get('gclid')
  if (gclidFromUrl && gclidFromUrl.trim() !== '') {
    localStorage.setItem('gclid', gclidFromUrl)
    _gclid = gclidFromUrl
  } else {
    _gclid = localStorage.getItem('gclid') || ''
  }
} catch (e) {
  // localStorage may be unavailable (e.g., privacy mode)
  _gclid = new URL(window.location.href).searchParams.get('gclid') || ''
}

let _clientId = ''

gtag('get', 'G-EWGTWHF6QQ', 'client_id', function (clientId) {
  // console.log('ggg', clientId)

  _clientId = clientId
  signup$a.forEach((el) => {
    // console.log('signup link', el)
    try {
      // Create a URL object relative to the current page.
      const url = new URL(el.getAttribute('href'), window.location.href)
      // Append (or update) the search parameter "data" to "value".
      url.searchParams.set('clientid', clientId)
      // Append gclid if available (from URL or persisted localStorage)
      if (_gclid && _gclid.trim() !== '') {
        url.searchParams.set('gclid', _gclid)
      }
      // Set the updated URL back as the element's href.
      el.setAttribute('href', url.href)
    } catch (error) {
      console.error('Failed to update URL for element:', el, error)
    }
  })
})
// setTimeout(() => {
//   ;(function () {
//     console.log('client id not found')
//     const param = 'clientid' // The name of the parameter to check
//     const value = _clientId
//
//     const url = new URL(window.location.href)
//     const params = url.searchParams
//
//     if (!params.has(param) || params.get(param) === '') {
//       params.set(param, value)
//       url.search = params.toString()
//       window.location.href = url.toString() // Refreshes the page with new URL
//     }
//   })()
// }, 1000)
